import React from "react";
import { Typography } from "antd";
const { Text } = Typography;

const ReshipmentAtNoCost = (): React.JSX.Element => {
    return <Text>Reshipment at No Cost</Text>;
};

export default ReshipmentAtNoCost;
